module.exports = __webpack_public_path__ + "static/img/banner-bg.044e9978.png";